import gql from 'graphql-tag';
import { typeDefs as userTypeDefs } from '../../hooks/useUser';
import { typeDefs as cookiesTypeDefs } from '../../hooks/useCookies';
import { typeDefs as errorModalTypeDefs } from '../../hooks/useErrorModal';
import { typeDefs as checkoutErrorTypeDefs } from '../../hooks/useCheckout/useCheckoutError';
import { typeDefs as notificationTypeDefs } from '../../hooks/useNotifications';

export const localTypeDefs = gql`
  ${userTypeDefs}
  ${cookiesTypeDefs}
  ${errorModalTypeDefs}
  ${checkoutErrorTypeDefs}
  ${notificationTypeDefs}

  extend type Query {
    cookies: Cookies
    user: User
    errorModal: ErrorModal
    checkoutError: CheckoutError
    notifications: [Notification!]!
  }
`;
